<template>
  <div>
    <h3>Error: 404</h3>
    <h2>Page not found</h2>
  </div>
</template>

<script>
export default {
  name: 'error-404',
};
</script>
